import {RouterView} from '../RouterView.js';
import Index from '../../components/views/admin/offices/Index';
import Create from '../../components/views/admin/offices/Create';
import Edit from '../../components/views/admin/offices/Edit';


// import utils from '@/utils/utils'
// const { checkPermission } = utils;

export default {
	path: 'oficinas',
	component: RouterView,
	children: [
		{
			path: '',
			component: Index
		},
        {
            path: 'crear',
            component: Create
        },
        {
            path: 'editar/:id',
            component: Edit,
            params: true,
        },
	]
}
